<div class="pl-10px pr-2 action-blue" title="Zoom in" (click)="zoom?.zoom(1)">+</div>
<div class="px-2 color-brand border-x" (click)="zoom?.reset()">100%</div>
<div class="pl-2 pr-10px action-blue" title="Zoom out" (click)="zoom?.zoom(-1)">-</div>
